import type { RetentionCohort } from '../types';

const getMockCohorts = (): RetentionCohort[] => [
    { label: 'Feb ’26', rates: [100, 92, 88, 84, 81, 78] },
    { label: 'Mar ’26', rates: [100, 94, 89, 86, 83] },
    { label: 'Apr ’26', rates: [100, 91, 87, 84] },
    { label: 'May ’26', rates: [100, 93, 90] },
    { label: 'Jun ’26', rates: [100, 95] },
    { label: 'Jul ’26', rates: [100] },
];

export default getMockCohorts;
